module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"moduleName":"Module name","numberOfElements":"Number of elements","typeFirstLetters":"Type the first letters"},"fr":{"moduleName":"Nom du module","numberOfElements":"Nombre d\u0027éléments","typeFirstLetters":"Taper les premières lettres"}}')
  delete Component.options._Ctor
}
